import React from 'react'
import { FaSearch, FaGoogle, FaBullhorn } from "react-icons/fa";
import Title from '../layouts/Title';
import Card from './Card';

const About = () => {
  return (
    <section
      id="about"
      className="w-full py-20 border-b-[1px] border-b-black"
    >
      <Title title="About me" des="What I Do" />
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 xl:gap-20">
        
        <Card
          title="Search Engine Optimization (SEO)"
          des="I help websites rank on Google using on-page, off-page & technical SEO."
          icon={<FaSearch />}
        />
        <Card
          title="Search Engine Marketing (SEM/PPC)"
          des="I manage Google Ads to bring instant traffic, leads, and sales."
          icon={<FaGoogle />}
        />
        <Card
          title="Social Media Marketing (SMM)"
          des="I grow brands on social media with content, engagement, and promotions."
          icon={<FaBullhorn />}
        />
      </div>
    </section>
  );
}

export default About